import AbstractPeriodColumnTemplateSource from "./AbstractPeriodColumnTemplateSource.js";
import BudgetPeriodColumnSource from "../../../reports/columns/periodColumnSource/BudgetPeriodColumnSource.js";

/**
 * This class is used when a period column template should fetch data
 * from the budget specified from the provided budget id. The main
 * difference with {@link DynamicBudgetPeriodColumnTemplateSource} is that
 * this class knows which budget will be used before interpretation, while the
 * budget remains unknown until interpretation for the other one.
 *
 * @param {string} budgetId - A unique identifier for the budget being
 *   used as source of data for the period column
 */
export default class StaticBudgetPeriodColumnTemplateSource extends AbstractPeriodColumnTemplateSource {
	constructor({ budgetId }) {
		super(...arguments);

		this._budgetId = budgetId;
	}

	isBudgetSource() {
		return true;
	}

	_instanceClass() {
		return BudgetPeriodColumnSource;
	}

	_interpretationSpec() {
		return {
			...super._interpretationSpec(...arguments),
			budgetId: this._budgetId,
		};
	}
}
